import React from 'react';
import './Project.css'

const Project = () => {
  return (
    <div className='py-12 min-h-screen'>

      <h1 className='text-white font-bold  text-3xl text-center mb-12'>MY     <span className='text-primary font-bold'>PROJECT</span></h1>

      <div className='grid py-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mt-6'>



        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/4YXvzgc/Capture.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Protfolio Website</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">React.js | Email.js | <br /> Swipper.js | React Icons </h2>
            <a href="https://relaxed-profiterole-dc95f6.netlify.app/">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/react-protfolio-website-1">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>





        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src=" https://i.ibb.co/4pVVknz/genius.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Practice Website</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">React.js | Node.js | <br /> Firebase   ||  Mongodb</h2>
            <a href="https://genius-f757a.web.app/">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/genius">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>


        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/wrNCX9Q/headphone.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Practice Website</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">React.js | ES6 | <br /> Vanilla CSS</h2>
            <a href="https://lucky-one-themarjanz.netlify.app">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/lucky-one-themarjanz">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>




        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/7YFk3bz/doctors-portal.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Practice Website</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">React.js | Node.js | <br /> Firebase | Mongodb</h2>
            <a href="https://doctors-portal-41c5a.web.app/">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/doctors-portal">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>







        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/vwtwX7L/4.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Company Website-Eparee</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">Wordpress</h2>
            <a target='_blank' href="https://www.eparee.com/" rel="noreferrer">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>

        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/z2nnjMQ/5.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">Resturanat Website-Food Court</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">Wordpress</h2>
            <a target='_blank' href="http://techwithfm.epizy.com/" rel="noreferrer">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>


        <div className="cart shadow-xl border-2 grid justify-center p-6">
          <div className=''>
            <img className='w-100%' src="https://i.ibb.co/ry8pcwt/6.png" class="max-w-sm  shadow-2xl" alt="" />
          </div>

          <div className="">
            <h2 class="text-2xl font-bold text-primary mt-2 mb-2">News Website- Go Sreemangal</h2>
            <h2 class="font-bold text-[18px] text-white mt-2 mb-2">Blogspot</h2>
            <a target='_blank' href="https://gosreemangal.blogspot.com/" rel="noreferrer">
              <button className='btn-style p-2 text-white m-2'>LIVE SITE</button>
            </a>
            <a href="https://github.com/themarjanz/">
              <button className='btn-style p-2 text-white m-2'>GIT CODE</button>
            </a>

          </div>
        </div>





      </div>
    </div>
  );
};

export default Project;




